export const handlerErrors = (error, alt) =>
  error && error.response && error.response.data
    ? error.response.data.message
    : alt
